import { h, render } from 'preact';


const Mobile = ({ data }) => (
    <div>
        <ul className="o-list-unstyled">
            {data.map((ability, abilityIndex) => {
                if (ability.key === false) {
                    return null;
                }

                return (
                    <li key={ability.key}>
                        <div className="c-frame">
                            <div className="o-aspect o-aspect--16x9">
                                <iframe
                                    width="560"
                                    height="315"
                                    src={`https://www.youtube.com/embed/${ability.youtubeId}?rel=0&showinfo=0`}
                                    frameBorder="0"
                                    allow="autoplay; encrypted-media"
                                    allowFullScreen
                                />
                            </div>
                        </div>

                        <div className="o-media">
                            <div className="o-media__block">
                                <div className="c-thumb c-thumb--big">
                                    <span className="o-aspect">
                                        <img src={`${window.versionedAssetPath}${ability.thumbnail}`} alt="" />
                                    </span>
                                </div>
                            </div>
                            <div className="o-media__block">
                                <h3 className="c-heading-28 u-color-white u-spacing-none">{ability.key}</h3>
                                <h3 className="c-heading-18 u-color-putty u-spacing-none">{ability.subtitle}</h3>
                            </div>
                        </div>

                        {ability.description.map(line => <p dangerouslySetInnerHTML={{ __html: line }} />)}

                    </li>
                );
            })}
        </ul>
    </div>
);

export default Mobile;



// WEBPACK FOOTER //
// ./src/js/AbilitiesPlayer/scenes/Mobile/index.jsx